import React, { PureComponent } from 'react'
import { Breadcrumb } from 'react-breadcrumbs'
import { withRouter } from 'react-router-dom'

import { Breadcrumbs } from 'Components/Breadcrumbs/index'
import { LayoutDashboard } from 'Components/Layout/Dashboard/index'
import { UserManagementWrapper } from 'Components/UserManagement/UserManagementWrapper'

import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'

import UserManagementIcon from 'Assets/Images/icons/userManagement'
import { PATHS } from 'Config/Routing/paths'
import {
  getUsers,
  setFilterClient,
  setFilterStatus,
  setFilterRole,
  setUsersSortBy,
} from 'Reducers/Users/actions'
import { getClients } from 'Reducers/Clients/actions'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { deleteUser } from '../../Reducers/Users/actions'
import { showReduxModal } from '../../Reducers/UI/actions'
import UsersListTable from './UsersListTable'
import SubmitButton from 'Components/Form/SubmitButton'
import { PageTitle } from '../../Components/PageTitle/index'

class UserManagement extends PureComponent {
  componentDidMount() {
    this.props.getUsers()
    this.props.getClients()
  }

  deleteUserById = async id => {
    await this.props.deleteUser(id)
    this.props.getUsers()
    this.props.getClients()
  }

  deleteUserByIdConfirmation = id => {
    const user = this.props.usersList.find(u => u.id === id)

    this.props.showReduxModal({
      title: 'Confirmation needed',
      onConfirm: () => this.deleteUserById(id),
      children: `Are you sure you want to delete ${user.firstName} ${
        user.lastName
      }?`,
      confirmLabel: `Confirm`,
    })
  }

  render() {
    const { usersList, match, history } = this.props

    return (
      <HideWhenBlocked>
        <UserManagementWrapper>
          <LayoutDashboard>{this.renderBreadcrumbs()}</LayoutDashboard>
          <div className="user-container">
            <PageTitle>User Management</PageTitle>
            <div>{this.renderAddUser()}</div>
          </div>
          <UsersListTable
            match={match}
            usersList={usersList}
            history={history}
            handleUserDelete={this.deleteUserByIdConfirmation}
          />
          {/* {this.renderUsersTable()} */}
        </UserManagementWrapper>
      </HideWhenBlocked>
    )
  }

  /**
   * Renders add new user button
   * @returns JSX.Element[]
   */
  renderAddUser() {
    return (
      <SubmitButton
        value="Add User"
        className="add-user"
        onClick={() =>
          this.props.history.push(`${this.props.match.url}/create`)
        }
      />
    )
  }

  /**
   * Renders breadcrumbs
   * @return JSX.Element[]
   */
  renderBreadcrumbs() {
    return (
      <div className="breadcrumbs">
        <Breadcrumbs icon={<UserManagementIcon style={{ width: 20 }} />} />
        <Breadcrumb
          data={{
            title: 'User management',
            pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
          }}
        />
      </div>
    )
  }
}

UserManagement.propTypes = {
  usersList: PropTypes.array,
  getUsers: PropTypes.func.isRequired,
  getClients: PropTypes.func.isRequired,
  setFilterClient: PropTypes.func.isRequired,
  setFilterStatus: PropTypes.func.isRequired,
  setFilterRole: PropTypes.func.isRequired,
  filterClient: PropTypes.string,
  filterStatus: PropTypes.string,

  setUsersSortBy: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  usersList: state.users.users,
  clientsList: state.clients.clientsList,
  filterClient: state.users.filterClient,
  filterStatus: state.users.filterStatus,
  filterRole: state.users.filterRole,
  sortBy: state.users.usersSortBy,
})

export default connect(
  mapStateToProps,
  {
    getUsers,
    getClients,
    setFilterClient,
    setFilterStatus,
    setFilterRole,
    setUsersSortBy,
    deleteUser,
    showReduxModal,
  },
)(withRouter(UserManagement))



// WEBPACK FOOTER //
// ./src/Containers/UserManagement/index.js